module.exports = __webpack_public_path__ + "static/media/dingSound.073e5f6c.wav";